import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
// NUOVA IN KENWOOD
const SliderChevronLeft = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <rect x="0.5" y="0.5" width="23" height="23" fill="white" />
            <rect x="0.5" y="0.5" width="23" height="23" stroke="#D11B59" strokeLinejoin="bevel" />
            <path
                d="M9.51507 12L16 5.29936L14.7425 4L7 12L14.7425 20L16 18.7006L9.51507 12Z"
                fill="#D11B59"
            />
        </Icon>
    )
}

SliderChevronLeft.propTypes = {onClick: PropTypes.func}

export default SliderChevronLeft
